// The data the whole Hub shares (who is signed in, flags, branding, …) lives in React Query under one root key, so
// lib/query-client.ts can configure it in one place. Each part's last key segment is its route under
// /resources/app-data.
export const APP_DATA_KEY = ['app-data'] as const;

export const appDataKey = <Part extends string>(part: Part) => [...APP_DATA_KEY, part] as const;
